import React from "react";
import { Route, Switch } from "react-router-dom";
import { Helmet } from "react-helmet";
import LandingPage from "./pages/LandingPage";
import config from "./config";
import { isMobile } from "./utils";
import LandingPageMobile from "./pages/LandingPageMobile";

export default function router(t) {
  return (
    <div className="app">
      <Helmet>
        <title>{config.APP_NAME}</title>
        <meta charSet="utf-8" />
        <meta name="description" content={t("metas:description")} />
      </Helmet>
      <Switch>
        <Route
          path="/"
          exact
          component={isMobile() ? LandingPageMobile : LandingPage}
        />
      </Switch>
    </div>
  );
}
